<div class="editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing" [width]="class['text-price']['width']"
      [height]="class['text-price']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- CHỮ VÀ ĐỊNH DẠNG -->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <div class="editor-field-body">
            <!-- Hiển thị đơn vị tiền tệ -->
            <div class="text-hidden">
              <span style="line-height: 1.5;">{{'hien_thi_khoang_gia' | translate}}</span>
              <nz-switch [(ngModel)]="config['is_display_range_price']" (ngModelChange)="updateConfig()"></nz-switch>
            </div>
            <!-- Hiển thị đơn vị tiền tệ -->
            <div class="text-hidden">
              <span style="line-height: 1.5;">Hiển thị đơn vị tiền tệ</span>
              <nz-switch [(ngModel)]="config['currency']['currency_check']"
                (ngModelChange)="updateConfig()"></nz-switch>
            </div>
            <!-- Hiển thị text khi giá = 0 -->
            <div class="text-hidden">
              <span style="line-height: 1.5;">{{'hien_thi_chu_khi_gia_la' | translate}} 0</span>
              <nz-switch [ngModel]="config.price_is_0?.enable"
                (ngModelChange)="togglePriceIs0($event)"></nz-switch>
            </div>
            <div *ngIf="config.price_is_0?.enable" class="config-text" style="width: 100%">
              <mat-form-field style="width: 100%">
                <mat-label> {{'noi_dung_khi_gia_la' | translate}} 0</mat-label>
                <textarea matInput
                  [ngModel]="staticdata['content_price_is_0_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
                  (ngModelChange)="staticdata['content_price_is_0_' + functionService.selectedLanguageCode] = $event"
                  (blur)="updateStaticData()" style="height: 50px"></textarea>
              </mat-form-field>
            </div>
            <div class="field-row">
              <div class="config-font-size">
                <!-- Font Family -->
                <div class="field-row-font" style="width:65%">
                  <mat-form-field style="width:100%">
                    <mat-label>Font</mat-label>
                    <mat-select [(ngModel)]="class['text-price__wrapper']['font-family']"
                      (ngModelChange)="updateClass();">
                      <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Font size -->
                <div class="field-row-size" style="width:35%;padding-right:5px">
                  <mat-form-field style="width:100%">
                    <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                    <input matInput type="number" [min]="1" [max]="200"
                      [ngModel]="class['text-price__content']['font-size'] | vhnumber"
                      (ngModelChange)="class['text-price__content']['font-size'] = $event +'px'" (blur)="updateClass()">
                  </mat-form-field>
                </div>
              </div>
            </div>
            <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
            <div class="field-row">
              <div class="config-font">
                <p class="title">{{'kieu_chu' | translate}}</p>
                <div class="font">
                  <!-- In đậm -->
                  <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                    class['text-price__content']['font-weight'] == 'bold'
                      ? 'primary'
                      : 'default'
                    " (click)="
                      class['text-price__content']['font-weight'] =
                        class['text-price__content']['font-weight'] == 'bold'
                          ? '400'
                          : 'bold'
                    " (click)="updateClass();">
                    <span style="font-weight: 500;">B</span>
                  </button>
                  <!-- In nghiêng -->
                  <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                    class['text-price__content']['font-style'] == 'italic'
                      ? 'primary'
                      : 'default'
                    " (click)="
                      class['text-price__content']['font-style'] =
                        class['text-price__content']['font-style'] == 'normal'
                          ? 'italic'
                          : 'normal'
                    " (click)="updateClass();">
                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- Gạch dưới -->
                  <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                    class['text-price__wrapper']['text-decoration'] == 'underline'
                      ? 'primary'
                      : 'default'
                    " (click)="
                      class['text-price__wrapper']['text-decoration'] =
                        class['text-price__wrapper']['text-decoration'] == 'none'
                          ? 'underline'
                          : 'none'
                    " (click)="updateClass();">
                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <input class="input-color" type="button" style="width:20%;flex:none;border-radius:5px;"
                    [style.background]="class['text-price__wrapper']['color']" [cpOKButton]="true"
                    [(colorPicker)]="class['text-price__wrapper']['color']" (colorPickerClose)="updateClass()" />
                </div>
              </div>
            </div>
            <!-- Canh lề -->
            <div class="field-row">
              <div class="config-font">
                <p class="title">{{'canh_le' | translate}}</p>
                <div class="font">
                  <button class="font-text-btn" nz-button [nzType]="
                      class['text-price__wrapper']['justify-content'] == 'flex-start'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['text-price__wrapper']['justify-content'] = 'flex-start';
                      class['text-price__content']['text-align'] = 'left';
                    " (click)="updateClass();">
                    <i nz-icon nzType="align-left" nzTheme="outline"></i>
                  </button>
                  <button class="font-text-btn" nz-button [nzType]="
                      class['text-price__wrapper']['justify-content'] == 'center'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['text-price__wrapper']['justify-content'] = 'center';
                      class['text-price__content']['text-align'] = 'center';
                    " (click)="updateClass();">
                    <i nz-icon nzType="align-center" nzTheme="outline"></i>
                  </button>
                  <button class="font-text-btn" nz-button [nzType]="
                      class['text-price__wrapper']['justify-content'] == 'flex-end'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['text-price__wrapper']['justify-content'] = 'flex-end';
                      class['text-price__content']['text-align'] = 'right';
                    " (click)="updateClass();">
                    <i nz-icon nzType="align-right" nzTheme="outline"></i>
                  </button>
                  <button class="font-text-btn" nz-button [nzType]="
                      class['text-price__content']['text-align'] == 'justify'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['text-price__wrapper']['justify-content'] = '';
                      class['text-price__content']['text-align'] = 'justify';
                    " (click)="updateClass();">
                    <i class="bi bi-justify"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="field-row">
              <div class="config-font" style="margin-top:20px">
                <!-- Khoảng cách chữ -->
                <div class="font-text-letterspacing">
                  <div class="config-name" style="gap:5px">
                    <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_chu' | translate }}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{ width: '40%' }"
                      [ngModel]="class['text-price__content']['letter-spacing'] | vhnumber" (nzBlur)="updateClass()"
                      (ngModelChange)="class['text-price__content']['letter-spacing'] = $event +'px'">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                        [ngModel]="class['text-price__content']['letter-spacing'] | vhnumber"
                        (nzOnAfterChange)="updateClass();"
                        (ngModelChange)="class['text-price__content']['letter-spacing'] = $event +'px'">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Khoảng cách dòng -->
                <div class="font-text-linespacing">
                  <div class="config-name">
                    <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_dong' | translate }}</p>
                    <nz-input-number [ngStyle]="{ width: '40%' }"
                      [(ngModel)]="this.class['text-price__content']['line-height']" (nzBlur)="updateClass()"
                      [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                        [(ngModel)]="this.class['text-price__content']['line-height']"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- PHONG CÁCH -->
      <li nz-submenu nzTitle="{{'phong_cach_va_kieu_co' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <app-text-style-config [config]="config" [class]="class" [staticdata]="staticdata" [device]="device"
          [objectChoosing]="objectChoosing" [textContentClass]="class['text-price__content']"
          [textWrapperClass]="class['text-price']" [filterConfig]="config['text-shadow']" [isShape]="false">
        </app-text-style-config>
      </li>

      <!-- Đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['text-price']"
          [shadowConfig]="config['box-shadow']" [objectChoosing]="objectChoosing">
        </app-shadow-config>
      </li>

      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderClass]="class['text-price']" [id_object]="objectChoosing._id">
        </app-borders-config>
      </li>

      <!-- BO TRÒN -->
      <li nz-submenu nzTitle="{{'bo_tron' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderRadiusClass]="class['text-price']" [id_object]="objectChoosing._id">
        </app-borders-radius-config>
      </li>

      <!-- THÊM LIÊN KẾT -->
      <li nz-submenu nzTitle="{{'lien_ket' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <app-link-page-config [type_page]="['detail_product']" [staticdata]="staticdata" [id_object]="objectChoosing._id"></app-link-page-config>
      </li>
      
      <!-- HIỆU ỨNG -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
        <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing"
          (openAnimationDetail)="openAnimationDetail($event)" [id_object]="objectChoosing._id" [device]="device"
          [class]="class" [config]="config" [staticdata]="staticdata" [cursorClass]="class['text-price']"
          [effect_hover]="effect_hover" [customize]="customize" [type]="'object'" [effectFileUsing]="'text'">
        </app-choose-animations-config>
      </li>

      <!-- Cấu hình thông số cơ bản của button-->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="this.config['animation-selected'].id != '000000'">
      <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device"
        [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"></app-animations-config>
    </div>
  </div>
</div>